import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "fixed bottom-0 z-50 w-full",
    "data-pop-up": ""
};
const _hoisted_2 = { class: "container flex w-full flex-col items-end" };
const _hoisted_3 = { class: "h-4 w-4 origin-center -rotate-90 transform transition-transform lg:h-5 lg:w-5" };
const _hoisted_4 = { class: "overflow-hidden" };
const _hoisted_5 = { class: "bg-white" };
const _hoisted_6 = { class: "container relative pt-5 md:pt-10" };
const _hoisted_7 = { class: "flex flex-col gap-8 pb-20 md:pb-12" };
const _hoisted_8 = { class: "mx-auto flex max-w-2xl flex-col gap-7 md:w-2/3 md:text-center" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "border-b border-black pb-6" };
const _hoisted_11 = { class: "mb-4" };
import { computed, reactive, ref } from 'vue';
import SvgIcon from '@atoms/SvgIcon.vue';
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
import NewsletterSignUpForm from '@molecules/NewsletterSignUpForm.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PopUp',
    props: {
        popUpTitle: {},
        popUpContent: {},
        popUpLink: {},
        popUpButtonText: {},
        addNewsletterForm: { type: Boolean },
        useNewsletterFooterContent: { type: Boolean },
        newsletterSignUp: {}
    },
    setup(__props) {
        const props = __props;
        const state = reactive({
            isOpen: false,
        });
        const newsletterFooterContent = ref('');
        const hasNewsletterFooterContent = computed(() => {
            return (newsletterFooterContent.value &&
                props.useNewsletterFooterContent &&
                props.addNewsletterForm);
        });
        const cloneNewsletterFooterContent = () => {
            // Get the inner html of data-newsletter-cta-content
            const newsletterContent = document.querySelector('[data-newsletter-cta-content]');
            if (newsletterContent) {
                const clonedContent = newsletterContent.cloneNode(true);
                const signUpForm = clonedContent.querySelector('[data-newsletter-sign-up-form]');
                //We don't want the sign-up form
                if (signUpForm) {
                    signUpForm.remove();
                }
                newsletterFooterContent.value = clonedContent.innerHTML;
            }
        };
        const openPopUp = () => {
            if (props.useNewsletterFooterContent && props.addNewsletterForm) {
                cloneNewsletterFooterContent();
            }
            state.isOpen = true;
            stopBodyScrolling();
        };
        const closePopUp = () => {
            state.isOpen = false;
            startBodyScrolling();
        };
        let savedScrollPosition = 0; // Store the scroll position
        const stopBodyScrolling = () => {
            savedScrollPosition = window.scrollY;
            document.body.style.overflow = 'hidden';
        };
        const startBodyScrolling = () => {
            document.body.style.overflow = 'auto';
            // Restore the scroll position
            window.scrollTo(0, savedScrollPosition);
        };
        return (_ctx, _cache) => {
            const _directive_dompurify_html = _resolveDirective("dompurify-html");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "absolute bottom-0 z-0 flex cursor-pointer items-center justify-between gap-4 bg-black p-4 text-white",
                        onClick: openPopUp
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.popUpButtonText) + " ", 1),
                        _createElementVNode("span", _hoisted_3, [
                            _createVNode(SvgIcon, { name: "chevron" })
                        ])
                    ])
                ]),
                _createVNode(_TransitionGroup, {
                    "enter-active-class": "fade__enter-active",
                    "enter-from-class": "fade__enter-from",
                    "enter-to-class": "fade__enter-to",
                    "leave-active-class": "fade__enter-active",
                    "leave-from-class": "fade__enter-to",
                    "leave-to-class": "fade__enter-from"
                }, {
                    default: _withCtx(() => [
                        (state.isOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "h-screen w-screen bg-black/50",
                                onClick: closePopUp
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", {
                    class: _normalizeClass([{
                            'grid-rows-0': !state.isOpen,
                            'grid-rows-1': state.isOpen,
                        }, "relative z-10 grid grid-cols-1 transition-all"])
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", {
                                        class: "h-4 w-4 origin-center rotate-90 transform cursor-pointer self-end transition-transform md:absolute md:h-8 md:w-8",
                                        onClick: closePopUp
                                    }, [
                                        _createVNode(SvgIcon, { name: "chevron" })
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        (hasNewsletterFooterContent.value)
                                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, null, 512)), [
                                                [_directive_dompurify_html,
                                                    newsletterFooterContent.value
                                                ]
                                            ])
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("h2", null, _toDisplayString(_ctx.popUpTitle), 1)
                                                ]),
                                                _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                                                    [_directive_dompurify_html, _ctx.popUpContent]
                                                ]),
                                                _createVNode(ButtonWithArrow, {
                                                    target: _ctx.popUpLink.target,
                                                    text: _ctx.popUpLink.title,
                                                    title: _ctx.popUpLink.title,
                                                    url: _ctx.popUpLink.url,
                                                    class: "md:mx-auto"
                                                }, null, 8, ["target", "text", "title", "url"])
                                            ], 64)),
                                        (_ctx.addNewsletterForm)
                                            ? (_openBlock(), _createBlock(NewsletterSignUpForm, {
                                                key: 2,
                                                "submission-page": _ctx.newsletterSignUp.submission_page
                                            }, null, 8, ["submission-page"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ], 2)
            ]));
        };
    }
});
